import React from 'react';
import RPassword from '../../components/RPassword/RPassword';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header/Header';

const RestorePasswordPage: React.FC = () => {
	const params = useParams();
	return (
		<>
			<Header>{''}</Header>
			<RPassword token={params.token} />
		</>
	);
};

export default RestorePasswordPage;
